import CoverageCheck from "./product.coverageCheck";
import ProductUtils from "./product.utils";

class Product {
  constructor() {}

  init() {
    console.info("Product init called");
    const productPageContainer = document.querySelector("#product-container");
    if (productPageContainer) {
      CoverageCheck.init();
      ProductUtils.addReadmoreHandler(
        "#product-readmore-link",
        "#product-full-content"
      );
    } else {
      console.warn("Product container not found!");
    }
  }
}

export default new Product();
